// Utility helpers for consistent gradient styling across the site.

export const levelGradients = {
  Foundational: 'from-[#422680] via-[#660F56] to-[#F54952]',
  Intermediate: 'from-[#1D4ED8] via-[#3B82F6] to-[#22D3EE]',
  Advanced: 'from-[#059669] via-[#10B981] to-[#34D399]',
  Mastery: 'from-[#B91C1C] via-[#F97316] to-[#FBBF24]',
};

export function getLevelGradient(level) {
  return levelGradients[level] || levelGradients.Foundational;
}
